var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8559 13.1424C9.6859 11.9724 8.8039 10.6624 8.2179 9.33341C8.0939 9.05241 8.1669 8.72341 8.3839 8.50641L9.2029 7.68841C9.8739 7.01741 9.8739 6.06841 9.2879 5.48241L8.1139 4.30841C7.3329 3.52741 6.0669 3.52741 5.2859 4.30841L4.6339 4.96041C3.8929 5.70141 3.5839 6.77041 3.7839 7.83041C4.2779 10.4434 5.7959 13.3044 8.2449 15.7534C10.6939 18.2024 13.5549 19.7204 16.1679 20.2144C17.2279 20.4144 18.2969 20.1054 19.0379 19.3644L19.6889 18.7134C20.4699 17.9324 20.4699 16.6664 19.6889 15.8854L18.5159 14.7124C17.9299 14.1264 16.9799 14.1264 16.3949 14.7124L15.4919 15.6164C15.2749 15.8334 14.9459 15.9064 14.6649 15.7824C13.3359 15.1954 12.0259 14.3124 10.8559 13.1424Z",
    stroke: "#0A0A0A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.2c55d30be0bd570d1dada78df5146834.svg";
export { ForwardRef as ReactComponent };